import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'
import {aPush} from '@modifi/router'

import SuccessDialog from './SuccessDialog'
import {
  selectSellerTradePartnerAllocatedLimit,
  selectSellerTradePartnerNameByExternalId,
} from '../../../../data/seller-trade-partners'

type OwnPropsParamsType = {
  externalTradePartnerId: string
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>, ownProps: {params: OwnPropsParamsType}) => ({
  allocatedLimit: ownProps?.params?.externalTradePartnerId
    ? selectSellerTradePartnerAllocatedLimit(state, ownProps.params.externalTradePartnerId)
    : {},
  tradePartnerName: ownProps?.params?.externalTradePartnerId
    ? selectSellerTradePartnerNameByExternalId(state, ownProps?.params?.externalTradePartnerId)
    : '',
})
const mapDispatchToProps = {
  closeDialog: aCloseDialog,
  redirect: aPush,
}

// @ts-expect-error handled with default props
export default connect(mapStateToProps, mapDispatchToProps)(SuccessDialog)

export const DIALOG_NAME = 'seller-trade-partner/final-step-success'
